import showPopup from "@/utils/showPopup.js";

export default async function showMessage(html) {
    showPopup(`<div class="popup-message">${html}</div>`, {
        rootClass: "message"
    });
}
